import { useContext, useState } from 'react';
import TuneIcon from '@mui/icons-material/Tune';
import WarningIcon from '@mui/icons-material/Warning';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { IMAGETYPE, ROUTES } from '../../../config/constants';
import { PatternContext } from '../../../providers/PatternProvider';
import ImageBrowseButton from '../Shared/ImageBrowseButton';
import PatternLibraryTextLink from '../Shared/PatternLibraryTextLink';
import { AdvancedSettingsModal } from './AdvancedSettingsModal';
import {
	stepContainerStyle,
	flexSpacerStyle,
	buttonTypographySx,
} from '../../../styles/patterns';

export const BrowseImage = (props) => {
	const { onNextClick } = props;

	const [showAdvancedModal, setShowAdvancedModal] = useState(false);
	const {
		imagePrimary,
		imageSecondary,
		imageType: imageTypeObj,
	} = useContext(PatternContext);

	const {
		dataURL: imagePrimaryDataURL,
		setDataURL: setImagePrimaryDataURL,
		jimpError: imagePrimaryJimpError,
	} = imagePrimary;
	const {
		dataURL: imageSecondaryDataURL,
		setDataURL: setImageSecondaryDataURL,
		jimpError: imageSecondaryJimpError,
	} = imageSecondary;
	const { value: imageType, setValue: setImageType } = imageTypeObj;

	const onShowAdvancedClick = () => {
		setShowAdvancedModal(true);
	};

	const isNextButtonDisabled = () => {
		const isPrimaryImageValid =
			imagePrimaryDataURL && !imagePrimaryJimpError;
		const isSecondaryImageValid =
			imageSecondaryDataURL && !imageSecondaryJimpError;

		if (imageType === IMAGETYPE.SINGLE) {
			return isPrimaryImageValid ? false : true;
		}
		//Double
		return isPrimaryImageValid && isSecondaryImageValid ? false : true;
	};

	return (
		<>
			<div
				style={{
					...stepContainerStyle,
					flexWrap: 'wrap',
				}}
			>
				<Button
					variant="text"
					size="large"
					color="inherit"
					onClick={onShowAdvancedClick}
					endIcon={<TuneIcon />}
					sx={{
						marginBottom: '20px',
						fontSize: '20px',
					}}
				>
					<Typography
						variant="h5"
						sx={{
							marginTop: '5px',
						}}
					>
						Advanced Settings
					</Typography>
				</Button>
				<AdvancedSettingsModal
					showAdvancedModal={showAdvancedModal}
					setShowAdvancedModal={setShowAdvancedModal}
					imageType={imageType}
					setImageType={setImageType}
				/>

				{isNextButtonDisabled() && (
					<PatternLibraryTextLink
						href={ROUTES.PATTERN_LIBRARY}
						variant="discover"
						align="center"
					/>
				)}

				<div style={flexSpacerStyle} />

				<div
					style={{
						display: 'flex',
						flexWrap: 'wrap',
						gap: '10px',
						justifyContent: 'center',
						marginBottom: '20px',
					}}
				>
					{/* Primary Image */}
					<div
						style={{
							display: 'flex',
							flexDirection: 'column',
							alignItems: 'center',
							width: '300px',
						}}
					>
						<ImageBrowseButton
							id={'1'}
							imageDataURL={imagePrimaryDataURL}
							callback={setImagePrimaryDataURL}
						/>
						{imagePrimaryJimpError && (
							<Tooltip
								title={
									<Typography variant="h5">
										{imagePrimaryJimpError}
									</Typography>
								}
							>
								<WarningIcon
									color="warning"
									sx={{ margin: '10px' }}
								/>
							</Tooltip>
						)}
					</div>

					{/* Secondary Image */}
					{imageType === IMAGETYPE.DOUBLE && (
						<div
							style={{
								display: 'flex',
								flexDirection: 'column',
								alignItems: 'center',
								width: '300px',
							}}
						>
							<ImageBrowseButton
								id={'2'}
								imageDataURL={imageSecondaryDataURL}
								callback={setImageSecondaryDataURL}
							/>
							{imageSecondaryJimpError && (
								<Tooltip
									title={
										<Typography variant="h5">
											{imageSecondaryJimpError}
										</Typography>
									}
								>
									<WarningIcon
										color="warning"
										sx={{ margin: '10px' }}
									/>
								</Tooltip>
							)}
						</div>
					)}
				</div>

				<div style={flexSpacerStyle} />

				<Button
					variant="contained"
					sx={{ boxShadow: 'none' }}
					disabled={isNextButtonDisabled()}
					onClick={onNextClick}
				>
					<Typography variant="h5" sx={buttonTypographySx}>
						Next
					</Typography>
				</Button>
			</div>
		</>
	);
};
